// extracted by mini-css-extract-plugin
export default {"list-recruit-container":"recruit_list-recruit-container__54In4","recruit-container":"recruit_recruit-container__t+S5E"};